import React from "react";
import { useState, useMemo } from "react";
import CustomTable from "../CustomTable";
import FormModal from "../FormModal";
import { Button, Form } from "react-bootstrap";
import RecordCount from "../utils/RecordCount";
import DeleteBlockedFormFields from "./DeleteBlockedFormFields";

const BlockList = (props) => {
  const [data, setData] = useState(
    useMemo(
      () =>
        props.blocked.map((obj) => ({
          ...obj,
          kind_name: obj.kind == 0 ? "id_340b" : "prefix",
        })),
      []
    )
  );
  const [showModalDelete, setShowModalDelete] = useState(false);
  const [modalDeleteId, setModalDeleteId] = useState(null);

  var deleteBlocked = (id) => {
    const url = `/blocked/${id}`;

    fetch(url, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').getAttribute("content"),
      },
    }).then((result) => {
      if (result.ok) {
        var dataCopy = [...data];
        dataCopy.splice(
          dataCopy.findIndex((obj) => obj.id == id),
          1
        );
        setData(dataCopy);
        setShowModalDelete(false);
      } else throw new Error("Network error.");
    });
  };

  const columns = useMemo(
    () => [
      {
        Header: "Network",
        accessor: "network",
        filter: "fuzzyText",
      },
      {
        Header: "Kind",
        accessor: "kind_name",
        filter: "fuzzyText",
      },
      {
        Header: "340B ID",
        accessor: "value",
        filter: "fuzzyText",
        Cell: (row) => <a href={`/entities/340bid/${row.value}`}>{row.value}</a>,
      },
      {
        Header: "Manufacturer",
        accessor: (row) => `${props.manufacturer_names[row.manufacturer]}`,
        filter: "fuzzyText",
        Cell: (tableProps) => (
          <small>{props.manufacturer_names[tableProps.row.original.manufacturer] || "none"}</small>
        ),
      },
      {
        Header: "Actions",
        id: "id",
        accessor: (str) => "delete",
        Filter: () => {},
        Cell: (tableProps) => (
          <>
            {props.can_destroy ? (
              <Button
                className="btn btn-danger btn-sm"
                onClick={() => {
                  setShowModalDelete(true);
                  setModalDeleteId(tableProps.row.original.id);
                }}
              >
                <i className="fa fa-trash"></i>
              </Button>
            ) : (
              "N/A"
            )}
          </>
        ),
      },
    ],
    []
  );

  return (
    <React.Fragment>
      {!props.hide_count ? <RecordCount record_count={data.length} /> : null}
      {data.length > 0 || props.hide_count ? <CustomTable columns={columns} data={data} /> : null}
      <FormModal
        show={showModalDelete}
        title="Delete Blocked"
        buttonText="Delete"
        buttonType="danger"
        modalId={`delete_blocked_${modalDeleteId}`}
        fields={
          <DeleteBlockedFormFields
            network={data.find((row) => row.id == modalDeleteId)?.network}
            kind_name={data.find((row) => row.id == modalDeleteId)?.kind_name}
            value={data.find((row) => row.id == modalDeleteId)?.value}
          />
        }
        action={`/blocked/${data.find((row) => row.id == modalDeleteId)?.id}`}
        dismiss={() => {
          setShowModalDelete(false);
        }}
      />
    </React.Fragment>
  );
};

export default BlockList;
